import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { DesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';

const displayControlTemplate = `
<div class="timeline-control" style="max-width: 800px">
  <div
  style="
    font-size: 18px;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-weight: 700;
    color: #6e6986;
    margin-top: 8px;
    display: block;
  ">
  Incident Timeline
  </div>
  <div data-timeline>
  <style>
  .incident-timeline-table p {
      margin-top: 8px;
      margin-bottom: 0px;
  }
  </style>
  <table class="incident-timeline-table" style="width: 100%; border-collapse: collapse; margin-top: 24px;">
  <tbody>
  <tr style="background-color: #000000; color: #ffffff; height: 40px; line-height: 40px;">
    <td style="width: 33%; font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 400; text-align: left; white-space: nowrap; padding-left:12px">
        <span style="font-weight: bold; text-transform: uppercase;">INITIAL REPORT</span> | <span>John Smith</span>
    </td>
    <td style="width: 33%"></td>
    <td style="width: 34% font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 400; text-align: right; white-space: nowrap; padding-right:12px">
        <span>Aug 6, 2021 at 2:30 PM EDT</span>
    </td>
  </tr>
  <tr>
      <td colspan="3" style="width: auto; font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 400; color: #000000;text-align: left;">
      <p>This is an example timeline entry. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
      </td>
  </tr>
  </tbody>
  </table>
  </div>
</div>`;
const settingsControlTemplate = ``;

export class TimelineControl extends DesignControl {
  public canEdit = false;
  public canCopy = false;
  public canDelete = true;

  constructor(document: Document, templateControlService: TemplateControlService) {
    super(document, templateControlService);

    this.controlTemplate = displayControlTemplate;
    this.settingsTemplate = settingsControlTemplate;
    this.controlType = TemplateControlType.Timeline;
  }

  public edit(): void {}

  public cancel(): void {}

  public save(): void {}

  public copy(): void {}
}
